import React from 'react';
import style from './assetLiabilities.scss';
import NoData from '../../../common/noData/NoData';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { Spin, Row, Col } from 'antd';
import { isNotEmpty } from '../../../../utils/util';

export default function MoneyAbstractBar({ enddateData, data, loading }) {

    let barOption = {
        color: ['#2365C4', '#F99248'],
        grid: {
            top: 50
        },
        legend: {
            right: '2%'
        },
        yAxis: [{
            type: 'value',
            color: '#88A3B4',
            nameTextStyle: {
                color: '#88A3B4'
            },
            axisLabel: {
                formatter: val => {
                    return val;
                }
            }
        }],
        category: enddateData,
        barData: data.barData,
        lineData: data.lineData
    };

    return (
        <div className={style.moneyAbstractBar}>
            <Row>
                <Col span={24}>
                    <div className={style.moneyBar}>
                        {loading ? <Spin tip="数据加载中..." /> :
                            isNotEmpty(barOption) ?
                            <BBDLineBar option={barOption} /> : <NoData />
                        }
                    </div>
                </Col>
            </Row>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/MoneyAbstractBar.jsx